import { useApps } from '@auth/useApps'
import { Account, AccountTypeEnum, getDelegatorPoints } from '@kudos/http-client'
import { AccountPermission, AppPermission, hasPermission } from '@shared/permissions'
import { useQuery } from '@tanstack/react-query'

export type UseCanSendPointsOptions = {
  delegatorId?: string
}

export type UseCanSendPointsResult = {
  canSendPoints: boolean
  delegatorAccounts: Account[] | undefined
  isDelegatorPointsFetched: boolean
}

export function useCanSendPoints(options: UseCanSendPointsOptions = {}): UseCanSendPointsResult {
  const { delegatorId } = options
  const [hasAppPermission] = useApps()

  const { data: delegatorAccounts, isFetched: isDelegatorPointsFetched } = useQuery({
    queryKey: ['delegatorPoints', delegatorId],
    queryFn: () => getDelegatorPoints(delegatorId ?? ''),
    enabled: !!delegatorId,
  })

  const delegatorAllocationAccount = delegatorAccounts?.find(
    account => account.type === AccountTypeEnum.ALLOCATION,
  )

  const canSendDelegatedPoints =
    delegatorAllocationAccount &&
    hasPermission(delegatorAllocationAccount, AccountPermission.SendDelegatedPoints)

  const canSendPoints =
    hasAppPermission('pointsApp', AppPermission.PointsAppSendPoints) &&
    (!delegatorId || Boolean(canSendDelegatedPoints))

  return {
    canSendPoints,
    delegatorAccounts,
    isDelegatorPointsFetched,
  }
}

export default useCanSendPoints
